import { Modal, Button, Alert } from "react-bootstrap";
import { addtReplacementOrder } from "../../../network/api/order.js";
import { useState } from "react";

const ReplaceRequest = ({ show, onHide, orderId, setRefreshComponent ,setShowReplace}) => {
  const [success, setSuccess] = useState("");
  const [error, setError] = useState(null);
  const handleWalletSubmit = async () => {
    addtReplacementOrder(orderId)
    .then((response) => {
      setSuccess(" order requested for replaced");
      setTimeout(() => {
        setRefreshComponent((prev) => !prev);
        setSuccess("");
        onHide();
      }, 2000);
    })
    .catch((err) => {
      setError("something went error"); // Set the error message
    });  };

  return (
    <Modal show={show} onHide={onHide} style={{ marginTop: '200px' }}>
    <Modal.Body>
      <div className="frame-420-header d-flex justify-content-between px-2">
        <div className="mt-4">
          <h4>هل انت متأكد من إستبدال المنتج ؟</h4>
        </div>
        <button onClick={() => setShowReplace(prev => !prev)} >
          <svg width="40" height="40" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.19526 3.13807C1.93491 2.87772 1.93491 2.45561 2.19526 2.19526C2.45562 1.93491 2.87772 1.93491 3.13807 2.19526L5.99999 5.05718L8.86189 2.19526C9.12225 1.93491 9.54438 1.93491 9.80473 2.19526C10.0651 2.45561 10.0651 2.87772 9.80473 3.13807L6.94279 5.99999L9.80473 8.86189C10.0651 9.12225 10.0651 9.54438 9.80473 9.80473C9.54438 10.0651 9.12225 10.0651 8.86189 9.80473L5.99999 6.94279L3.13807 9.80473C2.87772 10.0651 2.45562 10.0651 2.19526 9.80473C1.93491 9.54438 1.93491 9.12225 2.19526 8.86189L5.05718 5.99999L2.19526 3.13807Z" fill="#A5A5A5" />
          </svg>
        </button>
      </div>
      {success && (
        <div className="alert alert-success mt-1" role="alert">
          {success}
        </div>
      )}
      {error && <Alert variant="danger">{error}</Alert>}
      {!success &&
        <div className="d-flex justify-content-center gap-3 p-3">
          <Button
            variant="primary"
            style={{
              backgroundColor: "#C99700",
              border: "none",
              flexGrow: '1',
              fontSize: '18px'
            }}
            onClick={handleWalletSubmit}
          >Submit
          </Button>
          <Button
            style={{
              flexGrow: '1',
              backgroundColor: "transparent",
              border: '1px solid #bc0025',
              color: '#bc0025',
              fontSize: '18px'
            }}
            onClick={() => { onHide(); }}
          >Close
          </Button>
        </div>
      }
    </Modal.Body>
  </Modal>
  );
};

export default ReplaceRequest;
